package com.gsb.vyapar.bhagya.datasource.cache

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class SubCategoryEntity(
  public val id: Long,
  public val name: String,
  public val categoryId: Long,
  public val deleted: Boolean,
)
